export const LOAD_DATA = 'Loading data...';
export const NO_DATA = 'No data available.';
export const NO_COLUMNS = 'No columns available.';
